import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Dealer, DealerLocation, ExactCategory, ExactStandaloneLicense } from "models";

export type RemarkResponse = {
  exact_remark: string;
  exact_remark_updated_on: string;
  exact_remark_updated_by: string;
};

export type LicenseItem = {
  ID: string;
  Code: string;
  Country: string;
  Language: string;
  Description: string;
  StandardSalesPrice: number;
};

export type LicenseResponse = {
  categories?: ExactCategory[];
  standalone_licenses?: ExactStandaloneLicense[];
};

type PaginatedInvoice = {
  location: number;
  data: Record<number, PaginatedHistoricalInvoices>;
};

export type PaginatedInvoicesType = {
  data: PaginatedInvoice[];
};

export type HistoricalInvoice = {
  ID: number;
  AmountFC: number;
  Modified: string;
  Subject: string;
};

export type PaginatedHistoricalInvoices = {
  results: HistoricalInvoice[];
  __next?: string;
};

export type LocationLicensesDashboardFilters = {
  dealer: Dealer | null;
  location: DealerLocation | null;
};

const component = "LocationLicenseOverview";

export const LocationLicenseOverviewKeys = {
  paginatedInvoices: localQueryKey<PaginatedInvoicesType>({ component, data: "paginatedInvoices" }),
  filters: localQueryKey<LocationLicensesDashboardFilters>({ component, data: "filters" }),
  items: backendQueryKey<LicenseItem[]>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/licenses/items/list" }),
  remark: backendQueryKey<RemarkResponse>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/accounts/remark/read" }),
  invoices: backendQueryKey<PaginatedHistoricalInvoices>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/invoices/list" }),
  licenses: backendQueryKey<LicenseResponse>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/licenses/list" })
};
